<app-modal
  [(visible)]="visible"
  [showModalTitle]="false"
  [overlayMask]="false"
  [closeBtnEnabled]="false"
  (onHidden)="onHidden()"
  modalClass="splash-modal"
  [width]="isMobileMode && isHandsetLandscapeMode ? '50rem' : '60rem'"
  [height]="isMobileMode && isHandsetLandscapeMode ? '26rem' : '28rem'"
  maxWidth="90%"
  maxHeight="90%"
>
  <app-button
    appToolbarItemAfter
    buttonType="dark"
    styleType="text"
    shapeType="circle"
    sizeType="small"
    icon="assets/icons/xmark.svg"
    title="Fechar"
    (click)="visible = false"
  ></app-button>

  <ng-template modalContent>
    <div class="splash-modal-body">
      <div class="main-content">
        <div class="d-flex justify-content-center">
          <img class="logo" [src]="logoSrc" />
        </div>

        <p class="text">
          {{ this.ts.getCurrentLanguage()["splash-window-1"] }}<br />
          {{ this.ts.getCurrentLanguage()["splash-window-2"] }}
          <a class="link" href="javascript:void(0)" (click)="onHelpClick()">{{
            this.ts.getCurrentLanguage()["help"]
          }}</a
          >.
        </p>
      </div>

      <div class="actions-bottom">
        <app-button
          class="close-button"
          buttonType="dark"
          styleType="text"
          text="{{ this.ts.getCurrentLanguage()['close'] }}"
          (click)="visible = false"
        ></app-button>
      </div>
    </div>
  </ng-template>
</app-modal>
